import { Box, CircularProgress } from "@mui/material";
import React from "react";
import { useCaptureProtectionZone } from "../../../hooks/Capture";
import CaptureProtectionZone from "../ProtectionZone/CaptureProtectionZone";

interface ProtectionZoneTabProps {
  captureId?: string;
  handleError?: any;
  canEdit: boolean;
}

const ProtectionZoneTab: React.FC<ProtectionZoneTabProps> = ({ captureId, handleError, canEdit }) => {
  const { protectionZoneData, isPending, createProtectionZone, updateProtectionZone } = useCaptureProtectionZone(captureId);

  if (isPending && protectionZoneData === null) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <CaptureProtectionZone
      protectionZoneData={protectionZoneData}
      canEdit={canEdit}
      onCreate={async (values) => {
        await createProtectionZone(values).catch(handleError);
      }}
      onUpdate={async (id, values) => {
        await updateProtectionZone({ zoneId: id, values }).catch(handleError);
      }}
    />
  );
};

export default ProtectionZoneTab;
